const footerMenu = {
  items: [
    {
      items: [],
      label: 'Pontos + dinheiro',
      path: '/pointsandcash',
      createdAt: '2020-02-20T20:03:23.396Z',
      updatedAt: '2020-02-20T20:03:23.396Z'
    },
    {
      items: [],
      label: 'Segurança',
      path: '/security',
      createdAt: '2020-02-20T20:03:23.396Z',
      updatedAt: '2020-02-20T20:03:23.396Z'
    },
    {
      items: [],
      label: 'Termos de uso',
      path: '/terms',
      createdAt: '2020-02-20T20:03:23.396Z',
      updatedAt: '2020-02-20T20:03:23.396Z'
    },
    {
      items: [],
      label: 'Politica de Privacidade',
      path: '/privacy',
      createdAt: '2020-02-20T20:03:23.403Z',
      updatedAt: '2020-02-20T20:03:23.403Z'
    },
    {
      items: [],
      label: 'Política de Cookies',
      path: '/cookies-regulation',
      createdAt: '2020-02-20T20:03:23.396Z',
      updatedAt: '2020-02-20T20:03:23.396Z'
    },
    {
      items: [],
      label: 'Ajuda',
      path: '/redirect/faq',
      createdAt: '2020-02-20T20:03:23.403Z',
      updatedAt: '2020-02-20T20:03:23.403Z'
    },
    {
      items: [],
      label: 'Fale Conosco',
      path: '/redirect/contact',
      createdAt: '2020-02-20T20:03:23.403Z',
      updatedAt: '2020-02-20T20:03:23.403Z'
    }
  ],
  label: 'Rodapé Campanha Padrão',
  disclaimer:
    'Web Prêmios Comércio e serviços Promocionais Ltda. - CNPJ: 08.845.775/0001-70 - Inscrição Estadual: 206.247.436.112. \n O catálogo de premiação é atualizado de forma periódica e automaticamente pelos parceiros, e os produtos e preços poderão sofrer alterações durante a navegação, sem aviso prévio, devendo ser consultados pelo interessado no momento da conclusão efetiva do resgate.'
}

export default footerMenu



// WEBPACK FOOTER //
// ./src/redux/initial-state/footerMenu.js